module.exports = __webpack_public_path__ + "static/media/1.Petrol Chainsaw.1d11d1b1.jpg";